import { Show } from "solid-js";
import c from "class-c";

import Logo from "@repo/ui/branding/Logo";
import ContainerButton from "@repo/ui/buttons/ContainerButton";
import BackButton from "@repo/ui/navigation/BackButton";
import AppRouter from "@repo/utils-solid/AppRouter";

import { nativeDispatch } from "~/utils/mobile";
import { isWebview } from "~/utils/mobile";

import styles from "./CommunityNavbar.module.scss";

declare namespace CommunityNavbar {
  type Props = {
    onBack?: () => void;
  };
}

function CommunityNavbar({ onBack }: CommunityNavbar.Props) {
  return (
    <div class={c`${styles["nav"]} py-1`}>
      <div class={styles["left"]}>
        <Show when={AppRouter.depth() > 0}>
          <BackButton
            onClick={() => {
              if (onBack) return onBack();
              AppRouter.back.or("/");
            }}
          />
        </Show>
      </div>

      <Logo variant="full" />

      <div class={styles["right"]}>
        <Show when={isWebview()}>
          <ContainerButton
            onClick={() => {
              nativeDispatch("close");
            }}
            class="icon:medium"
          >
            
          </ContainerButton>
        </Show>
      </div>
    </div>
  );
}

export default CommunityNavbar;
